import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

export const logUserAction = async (user, action, details = null) => {
  try {
    await addDoc(collection(db, "userLog"), {
      email: user.email,
      displayName: user.displayName,
      timestamp: Timestamp.now(),
      action: action,
      details: details,
    });
  } catch (error) {
    console.error("Error logging user action:", error);
  }
};
